type TEXTAREA = {
  label?: string;
  htmlFor?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  value: string | undefined;
  setValue: (value: string | undefined) => void;
  className?: string;
  inputClassName?: string;
  error?: string;
  required?: boolean;
};

export const TextArea = ({
  label,
  htmlFor,
  name,
  id,
  placeholder,
  value,
  setValue,
  className = "",
  inputClassName = "",
  error,
  required,
}: TEXTAREA) => {
  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="flex mt-1 rounded-md shadow-sm">
        <textarea
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          id={id}
          className={`flex-1 block w-full px-3 py-2 border border-gray-300 bg-gray-50 rounded-md focus:ring-teal-500 focus:border-teal-500 sm:text-sm ${inputClassName}`}
          placeholder={placeholder}
          required={required}
        />
      </div>
      {error && <p>{error}</p>}
    </div>
  );
};
